import { useDispatch, useSelector } from 'react-redux';
import { useIsCurrentUserRateEditor, useIsSameUser } from '../../../../../../hooks/proposal/use-state-checker-proposal';
import { useRequirementUpload } from '../../../../../../hooks/actions/use-requirement-upload';
import { TypeOfActionProposal } from '../../../../../../types/type';
import { setIsForIssuancePolicy, setPolicyDataPageModalType, setPolicyType, setProposalIdForPolicy } from '../../../../../../features/ebam/plicy-data-page/policy-data-page.slice';
import { ProposalBook, ProposalCompute, ProposalDocumentSearch, ProposalDownload, ProposalEdit, ProposalRelease, ProposalView } from '../../../../../../assets/icon/svg';
import { setUpdateTypeModal } from '../../../../../../features/gms-state-and-modal/modal-slice';
import { useProposalTypeData } from '../../../../../../hooks/proposal/use-proposal-type-data';
import LoadingFile from '../../../../../ui/loading-file';
import LoadingViewFile from '../../../../../ui/loading-view-file';
import { useToastify } from '../../../../../../library/toastify/toast-provider';
import { setRatesTabs } from '../../../../../../features/actuarial/rates-slice';
import ComputationApprovalModal from '../../../../proposal-computation/modal/others/computation-approval-modal';
import { useComputationApprovalActions } from '../../../../../../hooks/actions/use-computation-approval-actions';
import { resetApproverForm, selectApprovalData, selectApprovalModalOpen, setIsOpenApproverModal } from '../../../../../../features/actuarial/approval/approval-slice';
import { useComputationActions } from '../../../../../../hooks/actions/user-computation-actions';
import { useFilesActions } from '../../../../../../hooks/actions/use-files-actions';
import { usePolicyActions } from '../../../../../../hooks/actions/use-policy-actions';
import { usePolicyDataState } from '../../../../../../hooks/policy/use-policy-data-state';
import ConfirmDefaultModal from '../../../../../global/modal/confirm-default-modal';
import { useModalAccess } from '../../../../../global/modal/use-modal-access';

interface Props {
    typeOfIcon: TypeOfActionProposal;
}

export default function ProposalActionBtn({ typeOfIcon }: Props) {

    const dispatch = useDispatch()
    const { showToastNotify } = useToastify();
    const { currentProposalId } = useModalAccess()
    const { 
        isLoadingGenerateCOC, 
        handleViewPolicy, 
        isLoadingViewPolicy,
        handleDownloadProposalPDF, 
        handleViewProposalPDF, 
        isLoadingDownloadProposalPDF, 
        isLoadingViewPDFProposal 
    } = useFilesActions()
    const {
        isShowModalForSubmitIssuance
    } = usePolicyDataState();
    const { handleShowModalConfirmRelease } = useComputationActions()
    const { handleShowModalConfirmBookedProposal } = useRequirementUpload()
    const { 
        isGCLIPOutstandingPolicy, 
        isGCLIPPrincipalPolicy, 
        isGADDPolicy,
        // DEPARTMENT
        isActuarialDepartment,
        isMarketingGMSDepartment,
        isEBAMDepartment,
        // STATUS: MARKETING GMS
        isBookedProposal,
        isReleaseProposal,
        isDraftProposal,
        isPendingProposal,
        isClosedProposal,
        isAmendProposal,
        isProposalApproved,
        // STATUS: ACtUARIAL
        isPassedComputation,
        isDeniedComputation,
        isQueuedComputation,
        isEndorsedComputation,
        isForApprovalComputation,
        isForReApprovalComputation,
        isForRatingComputation,
        isForAmendingComputation,
        // STATUS: POLICY EMBAM
        isContractCreationPolicy,
        isContractInProgressPolicy,
        isForContractReviewPolicy,
        isRevisionPolicy,
        isReadyForIssuancePolicy,
        isIssuedPolicy,
    } = useProposalTypeData();
    const {
        handleSubmitComputationForApproval,
        isLoadingSubmitComputationForApproval,
    } = useComputationApprovalActions()
    const {
        handleIssuedPolicyContract,
        isLoadingSubmitPolicyContract,
    } = usePolicyActions()

    const isCurrentUserRateEditor = useIsCurrentUserRateEditor();
    const showComputationBtn = isQueuedComputation || isForRatingComputation || isEndorsedComputation || isDeniedComputation || isForAmendingComputation; 
    const approvalData = useSelector(selectApprovalData);
    const endorsedByUserId = approvalData?.endorsed_by_user_id;
    const isEndorsed = endorsedByUserId === null ? false : !isCurrentUserRateEditor 
    const isComputationDisabled = !showComputationBtn || isClosedProposal || isBookedProposal || isEndorsed
    const canEdit = isDraftProposal || isPendingProposal
    const disabledComputationBtn = isReleaseProposal || isBookedProposal || isClosedProposal;
    const showSubmitBtn = !isReleaseProposal || isBookedProposal || isClosedProposal || isDeniedComputation || !isForAmendingComputation;
    const isSubmitDisabled = !showSubmitBtn || isClosedProposal || isBookedProposal || isPassedComputation || !isCurrentUserRateEditor
    const disabledReleaseBtn =  isBookedProposal || isClosedProposal || isAmendProposal;
    const canUpdate = isPendingProposal || isDraftProposal;
    const hideBtnSubmit = isPassedComputation || isForReApprovalComputation;
    const showReleaseBtn = isPassedComputation;
    const isReleaseDisabled = !showReleaseBtn || isClosedProposal || isBookedProposal || !isCurrentUserRateEditor;
    const isSameUser = useIsSameUser();
    const isOpenApprovalModal = useSelector(selectApprovalModalOpen)

    const primaryButton = `inline-flex min-h-9 w-full items-center justify-center gap-1.5 rounded-md border border-[#186cb2] bg-[#186cb2] px-2.5 py-2 text-[11px] font-semibold text-white transition-all hover:bg-[#145d99] active:scale-[0.98] disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#186cb2]/20 sm:min-h-10 sm:px-3 `;
    const secondaryButton=` inline-flex min-h-9 w-full items-center justify-center gap-1.5 rounded-md border border-[#186cb2]/40 bg-white px-2.5 py-2 text-[11px] font-semibold text-[#186cb2] transition-all hover:bg-[#186cb2]/5 active:scale-[0.98] disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#186cb2]/20 sm:min-h-10 sm:px-3`;
    const buttonClass = `flex items-center justify-center gap-1 w-full rounded px-3 py-1 text-xs text-white transition bg-[#186cb2] disabled:cursor-not-allowed`;
    const buttonClassViewDownload = `bg-white flex items-center justify-center gap-1 w-full rounded px-3 py-1 text-xs text-white transition border border-[#186cb2] disabled:cursor-not-allowed`;
    
    const handleUpdate = async () => {
        if(typeOfIcon === 'update') {
            if(!isSameUser) {
                return showToastNotify(`You don't have authorization to update this proposal`, 'warning')
            }
            if(!canUpdate) {
                return showToastNotify('Only draft or pending proposals can be updated.', 'warning')
            }
            // const isUpdatableStatusAllowed = 
            //     currentProposalStatusId === PROPOSAL_STATUS_IDS.DRAFT || 
            //     currentProposalStatusId === PROPOSAL_STATUS_IDS.CHECKING;
            // if (!isUpdatableStatusAllowed) {
            //     return showToastNotify(
            //         `You can't update proposal with status of ${currentProposalStatus}`,
            //         "warning"
            //     );
            // }
            dispatch(setUpdateTypeModal("updateProposal"));
        }

        if(typeOfIcon === 'compute') {
            // const isComputeStatusAllowed = 
            //     currentProposalStatusId === PROPOSAL_STATUS_IDS.CHECKING || 
            //     currentProposalStatusId === PROPOSAL_STATUS_IDS.PENDING
            // if (!isComputeStatusAllowed) {
            //     return showToastNotify(
            //         `You can't compute proposal with status of ${currentProposalStatus}`,
            //         "warning"
            //     );
            // }
            dispatch(setRatesTabs('rates'))
            dispatch(setUpdateTypeModal("updateProposal"));
        }
    }
    
    const handlePolicy = () => {
        if(currentProposalId === null) return
        if(!isGCLIPOutstandingPolicy && !isGCLIPPrincipalPolicy && !isGADDPolicy) {
            return showToastNotify('Only GCIP and GADD policies are currently available for policy creation.', 'warning')
        }
        dispatch(setPolicyDataPageModalType('policyDataPageGCLIP'))
        dispatch(setProposalIdForPolicy(currentProposalId))
        if (isGCLIPOutstandingPolicy) {
            dispatch(setPolicyType('GCLIP_OUT'));
        } else if (isGCLIPPrincipalPolicy) {
            dispatch(setPolicyType('GCLIP_PRIN'));
        } else if (isGADDPolicy) {
            dispatch(setPolicyType('GPA_GADDP'));
        }
    }

    return (
        <>
            {/* ================================================= */}
            {/* ACTUARIAL */}
            {/* ================================================= */}
            {isActuarialDepartment && (
                <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 lg:grid-cols-4">
                    {/* COMPUTE */}
                        <button type="button" disabled={isComputationDisabled} onClick={handleUpdate} className={primaryButton} >
                            <ProposalCompute color={isComputationDisabled ? '#9ca3af' : '#ffffff'} size={16} />
                            <span>Compute</span>
                        </button>
                    {/*SUBMIT FOR APPROVAL*/}
                        <button 
                            type="button" 
                            disabled={isSubmitDisabled} 
                            onClick={() => dispatch(setIsOpenApproverModal(true))} 
                            className={primaryButton} 
                        >
                            <ProposalRelease color={isSubmitDisabled ? '#9ca3af' : '#ffffff'} size={16} />
                            <span>Submit</span>
                        </button>
                    {/* RELEASE */}
                        <button type="button" disabled={isReleaseDisabled} onClick={handleShowModalConfirmRelease} className={primaryButton} >
                            <ProposalRelease color={isReleaseDisabled ? '#9ca3af' : '#ffffff'} size={16} />
                            <span>Release</span>
                        </button>
                    {/* )} */}
                    <button type="button" onClick={handleViewProposalPDF} className={secondaryButton} >
                        <ProposalView color="#186cb2" size={16} />
                        <span>View PDF</span>
                    </button>
                </div>
            )}

            {/* ================================================= */}
            {/* MARKETING GMS */}
            {/* ================================================= */}
            {isMarketingGMSDepartment && (
                <div className={`grid grid-cols-2 gap-2 ${isSameUser ? 'sm:grid-cols-4' : 'sm:grid-cols-2' } `}>
                    {/* UPDATE */}
                    {isSameUser && (
                        <button type="button" disabled={!canEdit} onClick={handleUpdate} className={primaryButton} >
                            <ProposalEdit color={!canEdit ? '#9ca3af' : '#ffffff'} size={16} />
                            <span>Update</span>
                        </button>
                    )}
                    {/* BOOK */}
                    {isSameUser && (
                        <button type="button" disabled={!isReleaseProposal} onClick={handleShowModalConfirmBookedProposal} className={primaryButton} >
                            <ProposalBook color={!isReleaseProposal ? '#9ca3af' : '#ffffff'} size={16} />
                            <span>Book</span>
                        </button>
                    )}
                    {/* VIEW */}
                    <button type="button" disabled={isDraftProposal} onClick={handleViewProposalPDF} className={secondaryButton} >
                        <ProposalView color={isDraftProposal ? '#9ca3af' : '#186cb2'} size={16} />
                        <span>View Proposal</span>
                    </button>
                    {/* DOWNLOAD */}
                    <button type="button" disabled={isDraftProposal} onClick={handleDownloadProposalPDF} className={secondaryButton} >
                        <ProposalDownload color={isDraftProposal ? '#9ca3af' : '#186cb2'} size={16} />
                        <span>Download</span>
                    </button>
                </div>
            )}
            {isEBAMDepartment && (
                <div className="grid grid-cols-3 gap-2 border-gray-300 pt-1.5">
                    <button
                        className={primaryButton}
                        disabled={isLoadingGenerateCOC || isLoadingSubmitPolicyContract || isLoadingViewPolicy}
                        onClick={handlePolicy} 
                    >
                        <ProposalEdit color="#ffffff" size={16} />
                        <span className='text-[11px]'>Edit Policy</span>
                    </button>
                    <button
                        className={primaryButton}
                        disabled={!isReadyForIssuancePolicy || isLoadingGenerateCOC || isLoadingSubmitPolicyContract || isLoadingViewPolicy}
                        // onClick={() => {
                        //     if(!proposalId) return;
                        //     handleIssuedPolicyContract(proposalId)
                        // }}
                        onClick={() => {
                            // dispatch(setConfirmTypeModal('isIssuancePolicy'))
                            dispatch(setIsForIssuancePolicy({isIssuancePolicy: true}))
                        }}
                    >
                        <ProposalRelease color="#ffffff" size={16} />
                        <span className='text-[11px]'>Submit</span>
                    </button>
                    <button
                        className={secondaryButton}
                        disabled={isLoadingGenerateCOC || isLoadingSubmitPolicyContract || isLoadingViewPolicy}
                        onClick={() => {
                            if(!currentProposalId) return 
                            handleViewPolicy(currentProposalId)
                        }}
                    >
                        <ProposalDocumentSearch color="#186cb2" size={16} />
                        <span className='text-[11px]'>View Policy</span>
                    </button>
                </div>
            )}
            {(isLoadingDownloadProposalPDF || isLoadingGenerateCOC) && (<LoadingFile />)}
            {(isLoadingViewPDFProposal || isLoadingViewPolicy) && (<LoadingViewFile />)}
            <ComputationApprovalModal
                isOpen={isOpenApprovalModal}
                onClose={() => {
                    dispatch(setIsOpenApproverModal(false))
                    dispatch(resetApproverForm())
                }}
                onRelease={handleSubmitComputationForApproval}
                isLoading={isLoadingSubmitComputationForApproval}
            />
            {isShowModalForSubmitIssuance && (
                <ConfirmDefaultModal
                    modalTitle={'Submit Policy Contract?'}
                    modalSubTitle={'Are you sure you want to submit this policy contract for final issuance? Please review the policy details before proceeding, as this action may finalize the submission.'}
                    onCancel={() => dispatch(setIsForIssuancePolicy({isIssuancePolicy: false}))}
                    onConfirm={() => {
                        if(!currentProposalId) return;
                        handleIssuedPolicyContract(currentProposalId)
                    }}
                    isLoading={isLoadingSubmitPolicyContract}
                />
            )}
        </>
        
    )
}

{/* {isEBAMDepartment && (
                <div className={`grid grid-cols-2 ${ isSameUser ? 'sm:grid-cols-3' : 'sm:grid-cols-2'} gap-2 pt-1.5 border-t border-gray-300`}>
                    <button
                        className={buttonClass}
                        disabled={isDraftProposal || hideBtn}
                        onClick={handlePolicy}
                    >
                        <ProposalEdit color="#ffffff" size={16} />
                        <span className='text-[11px]'>Edit Policy</span>
                    </button>
                    <button
                        className={buttonClass}
                        disabled={isDraftProposal || hideBtn}
                        onClick={handleShowModalConfirmBookedProposal}
                    >
                        <ProposalDocumentCheck color="#ffffff" size={16} />
                        <span className='text-[11px]'>Generate COC</span>
                    </button>
                    <button
                        className={buttonClass}
                        disabled={isDraftProposal || hideBtn}
                        onClick={handleShowModalConfirmBookedProposal}
                    >
                        <ProposalDocumentSearch color="#186cb2" size={16} />
                        <span className='text-[11px]'>View Policy</span>
                    </button>
                </div>
            )} */}
